import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DynamicRule, RuleEntity } from '@pdqdev/pdq-shared/dist/entities/Rules';
import { DeliveryCountdownTimerFormGroup } from './models';

enum DeliveryCountdownTimerFormTab {
  CONFIGURATIONS = 'configurations',
  APPEARANCE = 'appearance',
  DISPLAY_CONDITIONS = 'display-conditions',
}

@Component({
  selector: 'delivery-countdown-timer-form',
  templateUrl: './delivery-countdown-timer-form.component.html',
  styleUrl: './delivery-countdown-timer-form.component.scss',
  standalone: false,
})
export class DeliveryCountdownTimerFormComponent {
  @Input() formGroup: FormGroup<DeliveryCountdownTimerFormGroup>;
  @Input() displayRules: DynamicRule[];
  @Input() displayRulesEntities: RuleEntity[];
  @Input() shopCurrencySymbol: string;
  @Input() set shippingMethods(value: Array<{ id: number; name: string }>) {
    this._shippingMethods = value || [];
  }
  get shippingMethods(): Array<{ id: number; name: string }> {
    return this._shippingMethods;
  }
  private _shippingMethods: Array<{ id: number; name: string }> = [];

  tabs = [
    {
      label: 'Configurations',
      value: DeliveryCountdownTimerFormTab.CONFIGURATIONS,
    },
    {
      label: 'Appearance',
      value: DeliveryCountdownTimerFormTab.APPEARANCE,
    },
    {
      label: 'Display Conditions',
      value: DeliveryCountdownTimerFormTab.DISPLAY_CONDITIONS,
    },
  ];

  DeliveryCountdownTimerFormTab = DeliveryCountdownTimerFormTab;
  activeTab = DeliveryCountdownTimerFormTab.CONFIGURATIONS;

  onTabChange(event: DeliveryCountdownTimerFormTab) {
    this.activeTab = event;
  }
}
